{
    "coordinates": [
        -30.072871,
        -67.935122
    ],
    "tooltip": "Ischigualasto",
    "title": "Ischigualasto Formation",
    "country": "Argentina",
    "period": "Triassic",
    "alt": "TODO"
}
